import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Row, Breadcrumb, Button, Tabs, Col } from "antd";
import AllProducts from "../../AllProducts/index";
import { Link } from "react-router-dom";
import Can from "../../../../../casl/Can";
import { useGlobal } from "../../../../../store/index";
import ProductsCard from "../../ProductsCard";
import { ProductDetailsModalEditMode } from "components/ProductDetailsModal";
import { PERMISSIONS } from "constants/permissions";
import AlgoliaFilters from "../../../AlgoliaFilters/App";
import {
  connectHits,
  createInfiniteHitsSessionStorageCache,
} from "react-instantsearch-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";

export default function CategorywiseProducts() {
  const params = useParams();
  const categoryId = params?.id;
  const categoryName = params?.name;
  const [globalState, setGlobalState] = useGlobal();
  const { products } = globalState;
  const [pageNo, setPageNo] = useState(1);
  const [productsData, setProductsData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const { TabPane } = Tabs;
  const fields =
    "*, colours.colours_id.name,colours.colours_id.hexcode, product_images.directus_files_id,secondary_category.id,secondary_category.name";

  useEffect(() => {
    return () => {
      setGlobalState.products.clearProducts();
      setProductsData((prevState) => []);
    };
  }, [setGlobalState]);

  useEffect(() => {
    if (products) {
      setProductsData((prevState) => [...products?.data]);
    }
  }, [products]);

  const handleCardClick = (item) => {
    console.log(item);
    setModalData((state) => item);
    handleModal();
  };
  const handleModal = () => {
    setShowModal((state) => !state);
  };
  const sessionStorageCache = createInfiniteHitsSessionStorageCache();
  const InfiniteHits = ({
    hits,
    hasPrevious,
    refinePrevious,
    hasMore,
    refineNext,
  }) => (
    <div>
      <Row>
        {hits.map((item, index) => (
          <ProductsCard
            item={item}
            key={index}
            index={index}
            handleCardClick={handleCardClick}
            showModal={""}
            handleModal={""}
          />
        ))}
      </Row>
    </div>
  );
  const CustomInfiniteHits = connectHits(InfiniteHits);

  const fetchMoreData = (page) => {
    setPageNo((state) => page);
  };

  const operations = (
    <div>
      <Can
        I={PERMISSIONS.create_products.slug}
        a={PERMISSIONS.create_products.permissionType}
      >
        {(allowed) => (
          <div>
            <Button
              onClick={() => {
                history.push(`/add-product/${categoryName}/${categoryId}`);
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.ADD_PRODUCT,
                  GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                );
              }}
              //type="primary"
              size="large"
              style={{
                height: "2.5em",
                fontSize: "16px",
                float: "left",
                background: "#F0F8F6",
                color: "#0B7764",
                border: "1px solid #6DADA2",
                marginRight: "1em",
                // width: "48%",
              }}
            >
              Add product
            </Button>

            {/* <Button
              type="primary"
              onClick={() => {
                //openCategoryModal();
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.ADD_PRODUCT,
                  GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                );
              }}
              size="large"
              style={{
                height: "2.5em",
                fontSize: "16px",
                //background: "#363E3D",
                //color: "white",
                float: "right",
                // width: "48%",
              }}
            >
              Manage Products
            </Button> */}
          </div>
        )}
      </Can>
    </div>
  );

  const AddProductsCta = () => {
    return (
      //casl starts here
      <Can
        I={PERMISSIONS.create_products.slug}
        a={PERMISSIONS.create_products.permissionType}
      >
        {(allowed) => (
          <Button
            onClick={() => {
              history.push(`/add-product/${categoryName}/${categoryId}`);
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.MASTER_CATALOGUE,
                GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_ADD_PRODUCT_BUTTON,
                categoryId
              );
            }}
            type="primary"
            size="large"
          >
            Add Products
          </Button>
        )}
      </Can>
      //casl ends here
    );
  };
  const refresh = () => {};
  return (
    <>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link
              to="/"
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.RETURN,
                  GA.DESCRIPTION.RETURN_TO_HOME
                );
              }}
            >
              {" "}
              Home
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {" "}
            <Link
              to="/master-catalogue"
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.RETURN,
                  GA.DESCRIPTION.RETURN_TO_MASTER_CATALOGUE
                );
              }}
            >
              All Products
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{categoryName}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row style={{ marginTop: "1rem" }}>
        <Col span={24}>
          <Tabs
            defaultActiveKey="2"
            size="large"
            //onChange={callback}
            tabBarExtraContent={operations}
          >
            <TabPane
              tab={
                <span
                  style={{ fontSize: 20, fontWeight: "bold" }}
                  onClick={() => {
                    history.push(`/master-catalogue/${"2"}`);
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.MASTER_CATALOGUE,
                      GA.DESCRIPTION.ALL_PRODUCTS
                    );
                  }}
                >
                  All Products
                </span>
              }
              key="1"
            >
              <AllProducts />
            </TabPane>
            <TabPane
              tab={
                <span
                  style={{ fontSize: 20, fontWeight: "bold" }}
                  onClick={() => {
                    history.push(`/master-catalogue/${"2"}`);
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.MASTER_CATALOGUE,
                      GA.DESCRIPTION.ALL_PRODUCTS
                    );
                  }}
                >
                  Categories
                </span>
              }
              key="2"
            >
              <ProductDetailsModalEditMode
                showModal={showModal}
                setShowModal={setShowModal}
                refresh={refresh}
                id={modalData?.id}
              />
              <AlgoliaFilters
                Hits={<CustomInfiniteHits cache={sessionStorageCache} />}
                primaryText={categoryName}
                setCategory={true}
                //Cta={<AddProductsCta />}
                filter={`secondary_category.name:"${categoryName}"`}
                hideCategoryFilters
              />
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </>
  );
}
